import { useEffect } from "react"

export default function FlashData(map_ref, source_id, geo_json) {
  useEffect(() => {
    const source = map_ref?.getSource(source_id)
    if (source && geo_json) {
      source.setData(geo_json)
    }
  }, [geo_json, map_ref, source_id])
}
